import React, { useEffect, useState } from 'react';
import { FaCog, FaUsers, FaCode, FaClipboardList, FaLock, FaUserCog, FaDesktop } from 'react-icons/fa';
import IndstillingerGenerelt from './IndstillingerGenerelt';
import IndstillingerBrugere from './IndstillingerBrugere';
import IndstillingerAPI from './IndstillingerAPI';
import IndstillingerEftersynsskema from './IndstillingerEftersynsskema';
import IndstillingerAdgang from './IndstillingerAdgang';
import SettingsB2BPartners from '../pages/SettingsB2BPartners';
import IndstillingerKiosk from './IndstillingerKiosk';

const Indstillinger = ({ initialTab = 'generelt' }) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const tabs = [
    {
      id: 'generelt',
      name: 'Generelt',
      icon: FaCog,
      component: IndstillingerGenerelt
    },
    {
      id: 'kiosk',
      name: 'Kiosk',
      icon: FaDesktop,
      component: IndstillingerKiosk
    },
    {
      id: 'brugere',
      name: 'Brugere',
      icon: FaUsers,
      component: IndstillingerBrugere
    },
    {
      id: 'api',
      name: 'API',
      icon: FaCode,
      component: IndstillingerAPI
    },
    {
      id: 'eftersynsskema',
      name: 'Eftersynsskemaer',
      icon: FaClipboardList,
      component: IndstillingerEftersynsskema
    },
    {
      id: 'adgang',
      name: 'Adgang',
      icon: FaLock,
      component: IndstillingerAdgang
    },
    {
      id: 'b2b',
      name: 'B2B',
      icon: FaUserCog,
      component: SettingsB2BPartners
    }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  return (
    <div className="px-2 sm:px-4 md:px-6 py-2 sm:py-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Indstillinger</h1>
        <p className="text-gray-600 dark:text-gray-300 mt-1">Administrer systemets indstillinger</p>
      </div>

      {/* Navigation tabs */}
      <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
        <div className="overflow-x-auto no-scrollbar">
          <nav className="-mb-px flex space-x-6 sm:space-x-8 whitespace-nowrap px-1">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center flex-shrink-0 ${
                    activeTab === tab.id
                      ? 'border-falck-blue text-falck-blue'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-200 dark:hover:text-gray-100 dark:hover:border-gray-600'
                  }`}
                >
                  <Icon className="mr-2 h-4 w-4" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Active component */}
      {ActiveComponent && <ActiveComponent />}
    </div>
  );
};

export default Indstillinger;
